<div class="d-flex">
	<div class="d-flex align-items-center">
		<img [src]="syncImg()" alt="sync status" style="width: 4.5rem;">
	</div>
	<div class="ms-5">
		<div class="fw-bold px-2" [class.bg-error]="isWarning()" style="width: fit-content;">
			{{ labels().SYNCRONIZATION_COMPONENT_LAST_SYNC_DATE }}
			@if (lastSync(); as lastSync) {
			{{ lastSync | convertDate:false }} {{ lastSync | date:'HH:mm:ss':'UTC'}}
			} @else {
			{{ labels().SYNCRONIZATION_COMPONENT_NOT_SYNC }}
			}
		</div>
		<div class="fst-italic px-2 mt-3">{{ labels().SYNCRONIZATION_COMPONENT_NOTE }}</div>
	</div>
</div>